import { useNavigate, useParams } from 'react-router-dom'
import { trpc } from '../../../utils/trpc'
import { CycleStepType } from './types'

export const useTaskRouter = () => {
	const navigate = useNavigate()
	const { cycleId: internalCycleId } = useParams<{ cycleId: string }>()

	const handleTaskRouting = (taskId: string, cycleStepType: CycleStepType, externalCycleId?: string) => {
		const cycleId = externalCycleId || internalCycleId

		switch (cycleStepType) {
			case CycleStepType.EDIT_REVIEWERS_LIST:
				return navigate(`/cycle/${cycleId}/tasks/${taskId}/edit-reviewers-list`)
			case CycleStepType.APPROVE_REVIEWERS_LIST:
				return navigate(`/cycle/${cycleId}/tasks/${taskId}/approve-reviewers-list`)
			case CycleStepType.HOLD:
				return navigate(`/cycle/${cycleId}/tasks/${taskId}/hold`)
			case CycleStepType.CALIBRATION:
				// For calibration tasks, handle async session lookup
				handleCalibrationRouting(cycleId || '')
				return
			default:
				return navigate(`/cycle/${cycleId}/tasks/${taskId}/cycle-execution`)
		}
	}

	const handleCalibrationRouting = async (cycleId: string) => {
		try {
			// @ts-expect-error - TRPC query type compatibility issue
			const sessions = await trpc.client.calibrations.getSessions.query({
				cycleId,
				page: 1,
				perPage: 10,
				sortBy: 'createdAt',
				order: 'desc',
			})

			if (sessions && sessions.length > 0) {
				navigate(`/calibration/${cycleId}/${sessions[0].id}`)
			} else {
				console.warn('No calibration session found for this manager')
				navigate(`/dashboard/${cycleId}/tasks`)
			}
		} catch (error) {
			console.error('Error finding calibration session:', error)
			navigate(`/dashboard/${cycleId}/tasks`)
		}
	}

	return { handleTaskRouting }
}
